/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import Modal from '@hig/modal';
import { Error24 } from "@hig/icons";
import Typography from "@hig/typography";
import './modalFail.css';
import merge from "lodash.merge";
import HyperLink from './hyperlink';

const urlRegex = new RegExp("^(http|https)://", "i");

export class ModalFail extends Component {
    render() {
        const modalStyles = /* istanbul ignore next */ (styles) =>
            merge(styles, {
                modal: {
                    window: {
                        width: "371px",
                        height: "auto"
                    }
                }
            });

        let reportUrlOrMessage = null;
        let errorTitle = null;
        let isUrl = false;

        const errorData = this.props.errorData;

        if (typeof errorData === "object" && errorData !== null) {
            if (errorData.errorType) {
                switch (errorData.errorType) {
                    case 1:
                        isUrl = true;
                        reportUrlOrMessage = errorData.reportUrl;
                        break;

                    case 2:
                        isUrl = false;
                        errorTitle = errorData.title;
                        reportUrlOrMessage = errorData.messages?.join(", ");
                        break;

                    default:
                        if (errorData.message) {
                            reportUrlOrMessage = errorData.message;
                        } else {
                            reportUrlOrMessage =
                                "Unexpected error: " + JSON.stringify(errorData, null, 2);
                        }
                        break;
                }
            } else if (errorData.message) {
                reportUrlOrMessage = errorData.message;
            }
        } else if (typeof errorData === "string") {
            reportUrlOrMessage = errorData;
            isUrl = !!reportUrlOrMessage?.match(urlRegex);
        }

        const contentLabel =
            this.props.contentName === "Project:"
                ? "Projekt:"
                : (this.props.contentName || "Projekt:");

        return (
            <Modal
                open={this.props.open}
                title={this.props.title}
                percentComplete={null}
                stylesheet={modalStyles}
                headerChildren={
                    <header id="customFailHeader">
                        <div className="customFailHeaderContent">
                            <div className="title">
                                <Error24 className="errorIcon" />
                                <Typography
                                    style={{
                                        paddingLeft: "8px",
                                        fontSize: "inherit",
                                        fontWeight: "inherit",
                                        lineHeight: "inherit",
                                        color: "inherit"
                                    }}
                                >
                                    <>
                                        Aktualizowanie
                                        <br />
                                        {"nie powiod\u0142o si\u0119"}
                                    </>
                                </Typography>
                            </div>
                        </div>
                    </header>
                }
            >
                <div className="modalFailBody">
                    <div className="modalFailContent">
                        <div>
                            <Typography>
                                <span className="assemblyText">
                                    {contentLabel}
                                </span>
                                {this.props.label ? this.props.label : "Missing label."}
                            </Typography>
                        </div>

                        {reportUrlOrMessage && isUrl && (
                            <div className="logContainer">
                                <HyperLink link="Open log file" href={reportUrlOrMessage} />
                            </div>
                        )}

                        {reportUrlOrMessage && !isUrl && (
                            <div className="errorBlock">
                                {errorTitle && (
                                    <Typography className="errorMessageTitle">
                                        {errorTitle}
                                    </Typography>
                                )}
                                <Typography className="errorMessage">
                                    {reportUrlOrMessage}
                                </Typography>
                            </div>
                        )}
                    </div>

                    <div className="modalFailButtonsContainer">
                        <button
                            type="button"
                            className="modalFailPlainOkButton"
                            onClick={this.props.onClose}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ModalFail;